module.exports = __webpack_public_path__ + "assets/img/hzhb2.9b0a7371.png";